export default __webpack_public_path__ + "8a227ab211a647339aa795d14f57e7de.glb";